import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import { getAllGroupsInitiate } from '../../actions/groups';
import { getAllProgramsInitiate } from '../../actions/programs';
import { clearSuccessModal } from '../../actions/uiLogic';
import WalletPrograms from './WalletPrograms';
import { currentFlowTypeEnum } from '../common/components/constants';
import { getAllQuestionsInitiate } from '../../actions/questions';

const mapStateToProps = state => {
  const groupsData = _get(state, 'groups', {});
  const programsData = _get(state, 'programs', {});
  const companyData = _get(state, 'company', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    viewOnlyMode,
    groupsData,
    programsData,
    companyData,
    selectedWorkspace,
    fetchingGroups:
      _get(state, 'apiState.GET_GROUPS.isFetching', true) &&
      !_get(state, 'apiState.GET_GROUPS.isIdle', false),
    fetchingPrograms:
      _get(state, 'apiState.GET_PROGRAMS.isFetching', true) &&
      !_get(state, 'apiState.GET_PROGRAMS.isIdle', false),
    programId: _get(state, 'programs.programId', 0),
    programCreated: _get(state, 'apiState.CREATE_PROGRAM.success', false),
    fetchedPrograms: _get(state, 'apiState.GET_PROGRAMS.success', true),
    fetchedGroups: _get(state, 'apiState.GET_GROUPS.success', true),
    successModalClosed: _get(state, 'apiState.SUCCESS_MODAL.isIdle', false),
  };
};

const mapDispatchToProps = dispatch => ({
  getAllGroups: payload => dispatch(getAllGroupsInitiate(payload)),
  getAllPrograms: payload => dispatch(getAllProgramsInitiate(payload)),
  clearSuccessModal: () => dispatch(clearSuccessModal()),
  getAllQuestions: payload => dispatch(getAllQuestionsInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WalletPrograms);
